import Reveal, { SectionLabel } from "../components/Reveal";
import PageHero from "../components/PageHero";
import { CURRICULUM } from "../lib/site";
import {
  Mic,
  Megaphone,
  Drama,
  BookOpen,
  Lightbulb,
  Crown,
  Heart,
  Presentation,
} from "lucide-react";

const ICONS = [Megaphone, Mic, Drama, BookOpen, Lightbulb, Crown, Heart, Presentation];

export default function Curriculum() {
  return (
    <>
      <PageHero
        label="Curriculum"
        title={<>A curriculum crafted as carefully as a <em className="font-serif italic gold-text">conservatory</em>.</>}
        subtitle="Eight disciplines, woven together. Every program at BTSA is built from these foundational pillars — adapted with intention for each age group."
      />

      <section data-testid="curriculum-grid" className="ivory-section py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
            {CURRICULUM.map((c, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <Reveal key={c.title} delay={i * 0.05}>
                  <div
                    data-testid={`curriculum-${i}`}
                    className="bg-[#0a0a0a] h-full group hover:bg-[#111] transition-colors duration-500 relative overflow-hidden"
                  >
                    <div className="relative aspect-[16/10] overflow-hidden">
                      <img
                        src={c.image}
                        alt={c.title}
                        className="absolute inset-0 w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-[1.2s]"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                      <Icon size={22} className="absolute bottom-4 left-4 text-[#d4af37]" strokeWidth={1.2} />
                      <span className="absolute top-4 right-4 font-serif text-2xl text-white/90">
                        0{i + 1}
                      </span>
                    </div>
                    <div className="p-7">
                      <h3 className="font-serif text-2xl text-white font-light">
                        {c.title}
                      </h3>
                      <p className="mt-3 font-sans text-sm text-white/55 leading-relaxed">
                        {c.desc}
                      </p>
                      <div className="mt-6 h-px w-0 group-hover:w-12 transition-all duration-700 bg-[#d4af37]" />
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28 bg-[#080808] border-y border-white/5">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <Reveal>
            <div className="flex justify-center">
              <SectionLabel>The BTSA Method</SectionLabel>
            </div>
            <h2 className="mt-7 font-serif text-3xl lg:text-4xl font-light text-white leading-snug">
              We don't lecture children into confidence. We
              <span className="gold-text italic"> rehearse them into it</span> — through
              performance, reflection, refinement and applause.
            </h2>
          </Reveal>
        </div>
      </section>
    </>
  );
}
